"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _stencilReactDesc = require("@amzn/stencil-react-desc");

var _screenReaderOnly = require("../screen-reader-only");

var _text = require("../text");

var _propTypes = require("./propTypes");

var _core = require("@emotion/core");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var AvatarTextBase = _text.Text.withComponent('span', {
  target: "e1b9w7yl0"
});

AvatarTextBase.displayName = 'AvatarTextBase';
AvatarTextBase.propTypes = _text.Text.propTypes;
AvatarTextBase.defaultProps = _text.Text.defaultProps;

var AvatarText = function AvatarText(_ref) {
  var children = _ref.children,
      fontSize = _ref.fontSize,
      lineHeight = _ref.lineHeight,
      hiddenText = _ref.hiddenText;
  return (0, _core.jsx)(_react.default.Fragment, null, !!hiddenText && (0, _core.jsx)(_screenReaderOnly.ScreenReaderOnly, null, hiddenText), (0, _core.jsx)(AvatarTextBase, {
    display: "inline",
    fontSize: fontSize,
    lineHeight: lineHeight
  }, children));
};

AvatarText.displayName = 'AvatarText';
var AvatarTextWithDocs = (0, _stencilReactDesc.describe)(AvatarText).description('Used to display additional information about the employee.');
AvatarTextWithDocs.propTypes = _objectSpread({}, _propTypes.avatarTextPropTypes);
var _default = AvatarTextWithDocs;
exports.default = _default;